<template>
  <div class="basic">
    <div class="basic-header">
      <p>- Company Profile -</p>
    </div>
    <van-form label-width="8em" @submit="handleSubmit" ref="basicForm" validate-first @failed="onFailed">
      <!-- 企业基本信息   -->
      <van-field required v-model="formInline.companyNameEn" name="companyNameEn" label="Comapny name" placeholder="Please enter the Comapny name" :rules="ruleInline.companyNameEn" />
      <van-field type="number" v-model="formInline.linkFax" name="linkFax" label="Fax" placeholder="(Country Code)(Area Code)(Fax No.)" />
      <div>
        <van-field required readonly clickable name="addresss" :value="selectAddresTxt" right-icon="arrow" label="Country/District" placeholder="Please select Country/District"
          :rules="ruleInline.addresss" @click="showPicker = true" />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker show-toolbar :columns="areaList" @confirm="onConfirm" />
        </van-popup>
      </div>
      <van-field v-model="formInline.address" name="address" label="Address" placeholder="Please enter the address" :rules="ruleInline.address" required />
      <van-field required v-model="formInline.postcode" name="postcode" label="Postal code" placeholder="Please enter the postal Code" :rules="ruleInline.postcode" />
      <van-field required v-model="formInline.website" name="website" label="Website" placeholder="Please enter the pWebsite" :rules="ruleInline.website" />

      <div class="gap"></div>

      <!-- 展会联系人信息   -->
      <div class="top-title">
        <div class="line"></div>
        Contact Person<span>*</span>
      </div>

      <van-field required v-model="formInline.linkMan" name="linkMan" label="Name" placeholder="Please enter the name" :rules="ruleInline.linkMan" />
      <van-field required v-model="formInline.linkTitle" name="linkTitle" label="Position" placeholder="Please enter the position" :rules="ruleInline.linkTitle" />
      <van-field type="number" required v-model="formInline.linkMob" name="linkMob" label="Phone" placeholder="Please enter the phone " :rules="ruleInline.linkMob" />
      <van-field required v-model="formInline.linkEmail" name="linkEmail" label="E-mail" placeholder="Please enter the E-mail" :rules="ruleInline.linkEmail" />
      <van-field type="number" required v-model="formInline.linkTelephone" name="linkTelephone" label="Tel" placeholder="(Country Code)(Area Code)(Fax No.)" :rules="ruleInline.linkTelephone" />
      <div class="gap"></div>

      <!-- <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div> -->
    </van-form>
  </div>
</template>

<script> 
import { Toast } from 'vant';
import { mapGetters, mapActions } from "vuex";
import country from "@assets/js/country2-en";
export default {
  name: "register-form", // 参展申请 - 基本信息 
  data () {
    const that = this;
    // 判断英文
    const enValid = (value, callback) => {
      if (!value) {
        return true;
      } else {
        if (/^(?!\s*$)[A-Za-z0-9._\-\&\(\)\（）\s-]+$/.test(value)) {
          return true;
        } else {
          return false;
        }
      }
    };
    const companyAddressValid = (value) => {
      if (that.formInline.addresss.country && that.formInline.addresss.country === 'China') { // China 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          return false;
        } else if (!that.formInline.addresss.city) {
          return false;
        } else {
          return true;
        }
      } else {
        if (that.formInline.addresss.country) {
          return true;
        } else {
          return false;
        }
      }
    };
    const websiteValid = (value, callback) => {
      if (value) {
        if (/(http|https):\/\/([\w.]+\/?)\S*/.test(value)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    };
    const validPhone = (value, callback) => {
      if (!value) {
        return false;
      } else if (/^[1][0-9]{10}$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    const validEmail = (value, callback) => {
      if (!value) {
        return false;
      } else if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    return {
      areaList: [],
      showPicker: false,
      showPicker2: false,
      cityCode: '',  //省市区编号，默认
      loading: false,
      isInvoice: false,
      formInline: {
        // 企业基本信息 
        linkFax: "",
        companyName: "",// 公司英文名称 
        companyNameEn: "",// 公司英文名称 
        address: "", // 详细地址
        addresss: {
          country: "", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县 
        },
        postcode: "",
        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkTelephone: "",
        linkEmail: "",
        linkCode: "", // 区号
        linkMob: "", // 电话号码 
        website: "",
      },
      formInline2: {
        // 企业基本信息 
        linkFax: "",
        companyName: "lianzhan",// 公司英文名称
        companyNameEn: "lianzhan",// 公司英文名称
        address: "金沙江西路1555路慧创国际16号2层", // 详细地址
        addresss: {
          country: "China", // 国家
          province: "Beijing", // 省份
          city: "Xicheng", // 城市
          county: "", // 区县 
        },
        postcode: "201803",

        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "13122959676",
        linkEmail: "2624006658@qq.com",
        linkCode: "021", // 区号
        linkTelephone: "051-85055112", // 电话号码 
        website: "http://192.168.1.183:8081/ex-register-en/register-mobile", // 电话号码 
      },
      ruleInline: {
        // 企业基本信息  
        linkFax: [{ required: true, message: "Please enter the Fax", trigger: "onBlur" }],
        linkTelephone: [{ required: true, message: "Please enter the Mob", trigger: "onBlur" }],
        companyNameEn: [
          { required: true, message: "Please enter the company name", trigger: "onBlur" },
          { validator: enValid, message: "company format is not correct!", trigger: "onBlur" }
        ],
        website: [
          { required: true, message: "Please enter the website", trigger: "onBlur" },
          { validator: websiteValid, message: "website format is not correct!", trigger: "onBlur" }
        ],
        postcode: [{ required: true, message: "Please enter the postal code", trigger: "onBlur" }],
        addresss: [ 
          { required: true,validator: companyAddressValid, trigger: "onBlur", message: 'Supplementary address' }
        ],
        address: [
          { required: true, message: "Please enter the address", trigger: "onBlur" },
        ],

        // 展会联系人
        linkMan: [{ required: true, message: "Please enter the name", trigger: "onBlur" }],
        linkTitle: [{ required: true, message: "Please enter the position", trigger: "onBlur" }],
        linkMob: [
          { required: true, message: "Please enter the phone", trigger: "onBlur" },
          // { validator: validPhone, message: "phone format is not correct!", trigger: "onBlur" },
        ],
        linkEmail: [
          { required: true, message: 'Please enter the E-mail', trigger: 'onBlur' },
          {
            validator: validEmail, message: 'E-mail format is not correct!', trigger: "onBlur"
          }
        ],

      },

      countryList: [],
      provinceArr: [],
      citiesArr: [],

      selectAddresTxt: '',
      selectAddresTxt2: '',
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      company: "getCompany",
    }),
  },
  created () {
    this.areaList = country;
  },
  methods: {
    ...mapActions({
      getCityByParentId: "exhibitionModule/getCityByParentId",
    }),
    getvalidate (prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
        };
        this.validateList.push(opt);
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },
    async handleSubmit () {
      Toast.loading('loading...');
      setTimeout(() => {
        Toast.clear();
      }, 5000);
      let res = await this.validateHandle();
      console.log('res', res);
      return Promise.resolve(res)
    },
    async validateHandle () {
      return new Promise((resolve, reject) => {
        this.$refs.basicForm.validate().then(() => {
          // 营业执照
          let valid = true;
          let codeNum = this.formInline.linkTelephone.split('-');
          if (codeNum.length === 2) {
            this.formInline.linkCode = codeNum[0];
            this.formInline.linkTelephone = codeNum[1];
          }
          let form = this.formInline;
          let formValue = {
            linkFax: form.linkFax, // 公司名称 
            companyName: form.companyNameEn, // 公司名称 
            companyNameEn: form.companyNameEn,// 公司英文名称
            postcode: form.postcode, // 详细地址 
            address: form.address, // 详细地址 
            country: form.addresss.country,
            province: form.addresss.province,
            city: form.addresss.city,
            // 展会联系人
            linkMan: form.linkMan,
            linkTitle: form.linkTitle,
            linkTelephone: form.linkTelephone,
            linkEmail: form.linkEmail,
            linkCode: form.linkCode, // 区号
            linkMob: form.linkMob, // 电话号码 
            website: form.website, // 电话号码 
          }
          Toast.clear();
          if (!valid) {
            Toast.fail("Errors in forms submitted, please re-submit.");
          }
          resolve({ valid: valid, form: formValue });
        }).catch((res) => {
          //验证失败  
          this.$refs.basicForm.scrollToField(res[0].name, true)
          Toast.fail(res[0].message);
          resolve({ valid: false, form: null });
        })
      });
    },
    onConfirm (value) {
      this.formInline.addresss.country = value[0] || '';
      this.formInline.addresss.province = value[1] || '';
      this.formInline.addresss.city = value[2] || '';
      this.selectAddresTxt = `${this.formInline.addresss.country ? this.formInline.addresss.country : ''}${this.formInline.addresss.province ? '/' + this.formInline.addresss.province : ''}${this.formInline.addresss.city ? '/' + this.formInline.addresss.city : ''}`;
      this.showPicker = false;
    },
    onFailed (failed) {
      const errors = failed.errors;
      console.log(errors);
      this.$refs.basicForm.scrollToField(errors[0].name, true)
    }
  },
};
</script>

<style scoped lang='scss'>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #00a0e9 !important;
    }
    .van-switch--on,
    .ivu-radio-inner:after {
      background-color: #00a0e9;
    }
    .van-button--info,
    .van-radio__icon--checked .van-icon,
    .ivu-switch-checked {
      border-color: #00a0e9;
      background-color: #00a0e9;
    }
  }
  &-header {
    width: 100%;
    height: 48px;
    background-color: #00a0e9;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 48px;
      font-size: 15px;
    }
    span {
      width: 30px;
      height: 15px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 105px;
    height: 105px;
    border: dotted 1px #bfbfbf;
    text-align: center;
    margin: 10px 16px;
    border-radius: 4px;
    img {
      display: inline-block;
      width: 25px;
      height: 25px;
      margin-top: 33px;
      margin-bottom: 10px;
    }
    div {
      font-size: 12px;
      color: #999;
    }
  }
  .license-img {
    display: flex;
    flex-wrap: wrap;
    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;
      span {
        color: #00a0e9;
        cursor: pointer;
      }
      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;
    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;
      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;
    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;
      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;
    .ivu-checkbox-wrapper {
      margin: 0;
    }
    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}
.tip {
  padding: 10px 16px 0;
  .red {
    font-size: 12px;
    color: #f00;
  }
  .txt1 {
    font-size: 13px;
    color: #000;
    font-weight: bold;
  }
  .txt2 {
    font-size: 12px;
    color: #999;
  }
}
.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}
.top-title {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #00a0e9;
    margin-right: 7px;
  }
  span {
    font-size: 15px;
    color: #f00;
  }
  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}
.upload-btn2 {
  width: 105px;
  height: 105px;
  border: dotted 1px #bfbfbf;
  text-align: center;
  margin: 10px 16px;
  border-radius: 4px;
  position: relative;
  margin-left: 10px;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .cover {
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 3;
    .icon {
    }
  }
}
</style>
